import { createContext } from 'react';

var ConfigContext = /*#__PURE__*/createContext({
  locale: 'zh-CN'
});

export { ConfigContext as default };
